module.exports = __webpack_public_path__ + "8252839c49d7eac36e61bd35b4a831fb.svg";